import { SeatStatus } from "../enums/SeatStatus";
import { SeatRequest } from "../models/SeatRequest";

/**
 * How many members hold an upcoming Confirmed seat on the Session without being on its
 * series roster. Each member counts once, however many dates they booked; Requested
 * seats, past dates and roster members (counted through the roster) are left out.
 */
export const countSingleDateMembers = (
  seats: SeatRequest[],
  rosterMemberIds: string[],
  today: string,
): number => {
  const roster = new Set(rosterMemberIds);
  return new Set(
    seats
      .filter((s) => s.status === SeatStatus.Confirmed && s.occurrenceDate >= today && !roster.has(s.memberId))
      .map((s) => s.memberId),
  ).size;
};
